/**
 * Public app base URL for safety report PDFs and deep links.
 * Never returns localhost — use REACT_APP_PUBLIC_APP_URL or REACT_APP_PUBLIC_APP_ROOT.
 */
function isLocalhostUrl(url: string): boolean {
  try {
    const u = new URL(url)
    return u.hostname === 'localhost' || u.hostname === '127.0.0.1'
  } catch {
    return /localhost|127\.0\.0\.1/i.test(url)
  }
}

/**
 * Returns origin without trailing slash, e.g. https://didge.nexterarobotics.com
 * @throws If no suitable env URL is configured
 */
export function resolvePublicAppBaseUrl(): string {
  const primary = (process.env.REACT_APP_PUBLIC_APP_URL || '').trim()
  if (primary && !isLocalhostUrl(primary)) {
    return primary.replace(/\/$/, '')
  }
  const fallback = (process.env.REACT_APP_PUBLIC_APP_ROOT || '').trim()
  if (fallback && !isLocalhostUrl(fallback)) {
    return fallback.replace(/\/$/, '')
  }
  throw new Error(
    'Configure REACT_APP_PUBLIC_APP_URL (or REACT_APP_PUBLIC_APP_ROOT) to a public HTTPS URL for safety report links. Localhost is not allowed.',
  )
}

/** Hostname for display (preview copy); uses same resolution rules. */
export function resolvePublicAppHostname(): string {
  const base = resolvePublicAppBaseUrl()
  try {
    return new URL(base).hostname
  } catch {
    return base.replace(/^https?:\/\//i, '').split('/')[0] || base
  }
}
